import { ArrowRightFromLineIcon } from 'lucide-react';
import ControlButton from './ControlButton';

function NextButton({ onClick }: { onClick: () => void }) {
  return (
    <ControlButton onClick={onClick} aria-label="Next step">
      <ArrowRightFromLineIcon className="size-6" />
    </ControlButton>
  );
}

export default NextButton;
